import React from "react";
import { Tree, Tooltip, Alert } from "antd";
import { LoadingOutlined, CloseOutlined, FileOutlined, DownOutlined, RetweetOutlined } from '@ant-design/icons';
import { downloadSParameter, getDownLoadSParameterList, deleteSParameter } from "../../../services/download/sParameterCtrl";
import { generateDownloadSParameterList, PROCESSING_STATUS } from "../../../services/download/sParameterHelper";
import Transform from "./Transform";
import DownloadIcon from "./downloadIcon";
import './index.css'

/**
 * props: {channelId, interfaceId, product}
 */
class SParameterContent extends React.Component {
  constructor() {
    super();
    this.state = {
      treeData: [],
      openTransformData: {},
      expandedKeys: [],
      isUpdateTransformSnp: false,
      downloadingKeys: [],
      isExistTransforming: false,
    }
    this.timeInterval = null;
  }

  async componentDidMount() {
    await this.setDownloadTree(true);
  }

  componentWillUnmount() {
    this.updateTimeInterval("clear");
  }

  setDownloadTree = async (isFirst = false) => {
    const { channelId, product } = this.props;
    const res = await getDownLoadSParameterList({ channelId, product });
    if (!res) return;
    const { treeData, isExistTransforming } = generateDownloadSParameterList(res);
    if (!isExistTransforming) {
      this.updateTimeInterval("clear");
    } else if (!this.timeInterval) {
      this.updateTimeInterval("create");
    }
    const { openTransformData } = this.state;
    if (isFirst) {
      this.setState({
        treeData,
        expandedKeys: Array.from({ length: 5 }).map((_, i) => (treeData[i] || {}).key).filter(Boolean),
        isExistTransforming
      })
    } else {
      let newOpenTransformData = {};
      if (!!openTransformData.snpUrl && !openTransformData.isOnlyRead) {
        const nodeData = treeData.find(item => item.key === openTransformData.snpUrl) || {};
        newOpenTransformData = { ...(nodeData.nodeInfo || {}) }
      }

      this.setState({
        treeData,
        isUpdateTransformSnp: !!openTransformData.snpUrl && !openTransformData.isOnlyRead,
        openTransformData: newOpenTransformData,
        isExistTransforming
      })
    }
  }

  downloadFile = async (e, nodeData) => {
    e && e.stopPropagation();
    const { downloadingKeys } = this.state;
    if (downloadingKeys.includes(nodeData.key)) return;
    this.setState({ downloadingKeys: [...downloadingKeys, nodeData.key] }, (prevState) => {
      const { downloadingKeys } = this.state;
      const fileName = nodeData.title.replace(/.s[0-9]{1,}p$/ig, '');
      downloadSParameter(nodeData.key, fileName).then(() => {
        this.setState({ downloadingKeys: downloadingKeys.filter(key => key !== nodeData.key) })
      }).catch((error) => {
        console.log(error);
        this.setState({ downloadingKeys: downloadingKeys.filter(key => key !== nodeData.key) })
      })
    })
  }

  openTransform = (e, nodeData, isOnlyRead = false) => {
    e && e.stopPropagation();
    this.setState({
      openTransformData: { ...nodeData.nodeInfo, isOnlyRead }
    })
  }

  deleteTransformFile = async (e, nodeData) => {
    e && e.stopPropagation();
    await deleteSParameter(nodeData.key);
    this.setDownloadTree();
  }

  titleRender = (nodeData) => {
    const { downloadingKeys } = this.state;
    const nodeInfo = nodeData.nodeInfo || {};
    return <div className="tree-item">
      <span className="file-name">
        <FileOutlined />
        {nodeData.title}
      </span>
      <div className="button-group">
        {
          nodeInfo.status === PROCESSING_STATUS
            ? <Tooltip title="Transforming a Touchstone file.">
              <span><LoadingOutlined /></span>
            </Tooltip>
            : <>
              <Tooltip
                title={downloadingKeys.includes(nodeData.key) ? `Preparing a file.\nIt may take a few minutes to start downloading.` : "Download"}
                classNames={{ root: 's-parameter-download-icon-tooltip' }}>
                <span onClick={(e) => this.downloadFile(e, nodeData)}>
                  <DownloadIcon loading={downloadingKeys.includes(nodeData.key)} />
                </span>
              </Tooltip>
              {nodeData.isTransformFile
                ? <Tooltip title="Delete">
                  <span onClick={(e) => this.deleteTransformFile(e, nodeData)}>
                    <CloseOutlined />
                  </span>
                </Tooltip>
                : <Tooltip title="Transform">
                  <span onClick={(e) => this.openTransform(e, nodeData)}>
                    <RetweetOutlined />
                  </span>
                </Tooltip>}
            </>
        }
      </div>
    </div>
  }

  onExpand = (expandedKeys) => {
    this.setState({
      expandedKeys,
    })
  }

  updateTimeInterval = (type) => {
    if (type === "clear" && this.timeInterval) {
      clearInterval(this.timeInterval);
      this.timeInterval = null;
    } else if (type === "create" && !this.timeInterval) {
      this.timeInterval = setInterval(() => {
        this.setDownloadTree();
      }, 3000);

      const timeNow = setInterval(() => {
        this.setDownloadTree();
        clearInterval(timeNow);
      }, 500);
    }
  }

  render() {
    const { treeData, openTransformData, expandedKeys, isUpdateTransformSnp, isExistTransforming, downloadingKeys } = this.state;
    return (
      <div className="s-parameter-content">
        {isExistTransforming || downloadingKeys.length > 0
          ? <Alert
            message="Download or transform is in progress, you may close this window."
            type="warning"
            showIcon
            className="s-parameter-content-alert"
          />
          : null}
        <Tree
          showLine
          switcherIcon={<DownOutlined />}
          treeData={treeData}
          blockNode
          titleRender={this.titleRender}
          className="file-name-tree"
          selectedKeys={[openTransformData.snpUrl]}
          expandedKeys={expandedKeys}
          onExpand={this.onExpand}
          onSelect={(_, e) => this.openTransform(undefined, e.node, true)}
        />
        {openTransformData.snpUrl
          ? <Transform
            isUpdateTransformSnp={isUpdateTransformSnp}
            openTransformData={openTransformData}
            updateTimeInterval={this.updateTimeInterval}
            updateIsUpdateTransformSnp={() => this.setState({ isUpdateTransformSnp: false })}
            closeModal={() => this.setState({ openTransformData: {} })}
          />
          : null}
      </div>
    );
  }
}

export default SParameterContent;